import { MODULE_PATHS } from "./constants";
import { EVENT, SCREEN } from "./constants.analytics";

export const getContactEventDetails = (module:string) => {
    let analyticsDetails = {eventName:"",screenName:""};
    let eventName = "";
    let screenName = "";
    if (module.includes("MyLoad")) {
      if (module === MODULE_PATHS.CARRIER_TENDERED ) {
        eventName = EVENT.CONTACT_US_CARRIER_TENDERED
        screenName = SCREEN.MYLOADS_CARRIER_TENDERED
      }
      else if (module === MODULE_PATHS.CARRIER_ASSIGNED ) {
        eventName = EVENT.CONTACT_US_CARRIER_ASSIGNED
        screenName = SCREEN.MYLOADS_CARRIER_ASSIGNED
      }
      else if (module === MODULE_PATHS.DRIVER_ASSIGNED) {
        eventName = EVENT.CONTACT_US_DRIVER_ASSIGNED
        screenName = SCREEN.MYLOADS_DRIVER_ASSIGNED
      }
      else if (module === MODULE_PATHS.INTRANSIT) {
        eventName = EVENT.CONTACT_US_IN_TRANSIT
        screenName = SCREEN.MYLOADS_IN_TRANSIT
      }
      else if (module === MODULE_PATHS.DELIVEREDNEEDSPPWK) {
        eventName = EVENT.CONTACT_US_DELIVERED_NEEDS_PPWK
        screenName = SCREEN.CONTACT_US_DELIVERED_NEEDS_PPWK
      }
      if (module === MODULE_PATHS.DELIVEREDWITHPPWK) {
        eventName = EVENT.CONTACT_US_DELIVERED_WITH_PPWK
        screenName = SCREEN.CONTACT_US_DELIVERED_WITH_PPWK
      }
      analyticsDetails = { eventName: eventName, screenName: screenName }
    }
    return analyticsDetails;
  } 